module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/changing_asanen-9367b5464e3e33c8b5e38032bc1e4212.jpg";